import {
  Component,
  OnDestroy,
  Input,
  Inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'lib-spinner',
  template: `
    <div class="preloader" *ngIf="spinnerVisible$ | async">
      <div class="spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent implements OnDestroy {
  private spinnerVisibleSub = new BehaviorSubject<boolean>(true);
  spinnerVisible$ = this.spinnerVisibleSub.asObservable();

  @Input() public backgroundColor = 'rgba(239, 138, 30, 0.69)';

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.spinnerVisibleSub.next(true);
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.spinnerVisibleSub.next(false);
        }
      },
      () => {
        this.spinnerVisibleSub.next(false);
      }
    );
  }

  ngOnDestroy(): void {
    this.spinnerVisibleSub.next(false);
  }
}
